import { useTranslation } from "react-i18next";
import { SharedSentIcon } from "@monorepo/icons";
import { DeleteIcon, ShareIcon } from "@monorepo/icons";
import theme from "@monorepo/styles/theme";
import { Box, Tooltip } from "@mui/material";
import Button from "@mui/material/Button/Button";

interface IProps {
  onAction?: (() => void) | null;
  onDelete?: (() => void) | null;
  onShare?: (() => void) | null;
  onClientsClick?: (() => void) | null;
  actionIcon: React.ReactNode;
  onActionTooltipText?: string;
  onDeleteTooltipText?: string;
  onShareTooltipText?: string;
  onClientsClickTooltipText?: string;
}

export const PopoverMenu: React.FC<IProps> = ({
  onAction,
  onDelete,
  onShare,
  onClientsClick,
  actionIcon,
  onActionTooltipText,
  onDeleteTooltipText,
  onShareTooltipText,
  onClientsClickTooltipText,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "grid",
        justifyContent: "center",
        gridRowGap: theme.spacing(2),
        padding: theme.spacing(1),
      }}
    >
      {typeof onAction !== "undefined" &&
        onAction !== null &&
        (onActionTooltipText ? (
          <Tooltip title={String(t(onActionTooltipText))}>
            <Button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onAction();
              }}
              sx={{
                minWidth: "unset",
                padding: theme.spacing(1),
              }}
            >
              {actionIcon}
            </Button>
          </Tooltip>
        ) : (
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onAction();
            }}
            sx={{
              minWidth: "unset",
              padding: theme.spacing(1),
            }}
          >
            {actionIcon}
          </Button>
        ))}
      {typeof onDelete !== "undefined" &&
        onDelete !== null &&
        (onDeleteTooltipText ? (
          <Tooltip title={String(t(onDeleteTooltipText))}>
            <Button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onDelete();
              }}
              sx={{
                minWidth: "unset",
                padding: theme.spacing(1),
              }}
            >
              <DeleteIcon fontSize="small" />
            </Button>
          </Tooltip>
        ) : (
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDelete();
            }}
            sx={{
              minWidth: "unset",
              padding: theme.spacing(1),
            }}
          >
            <DeleteIcon fontSize="small" />
          </Button>
        ))}
      {typeof onShare !== "undefined" &&
        onShare !== null &&
        (onShareTooltipText ? (
          <Tooltip title={String(t(onShareTooltipText))}>
            <Button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onShare();
              }}
              sx={{
                minWidth: "unset",
                padding: theme.spacing(1),
              }}
            >
              <ShareIcon fontSize="small" />
            </Button>
          </Tooltip>
        ) : (
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onShare();
            }}
            sx={{
              minWidth: "unset",
              padding: theme.spacing(1),
            }}
          >
            <ShareIcon fontSize="small" />
          </Button>
        ))}
      {typeof onClientsClick !== "undefined" &&
        onClientsClick !== null &&
        (onClientsClickTooltipText ? (
          <Tooltip title={String(t(onClientsClickTooltipText))}>
            <Button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClientsClick();
              }}
              sx={{
                minWidth: "unset",
                padding: theme.spacing(1),
              }}
            >
              <SharedSentIcon />
            </Button>
          </Tooltip>
        ) : (
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClientsClick();
            }}
            sx={{
              minWidth: "unset",
              padding: theme.spacing(1),
            }}
          >
            <SharedSentIcon />
          </Button>
        ))}
    </Box>
  );
};
